import { Component, Injector } from '@angular/core';
import { ViewModalComponent } from 'projects/kiosk-app/src/app/components';

@Component({
  selector: 'app-view-nick-name',
  templateUrl: './view-nick-name.component.html',
  styleUrls: ['./view-nick-name.component.scss']
})
export class ViewNickNameComponent extends ViewModalComponent {
  constructor(injector: Injector) {
    super(injector);
  }
}